
export const ProfilerQuestionID = {
	// Business
	INDUSTRY: 'industry',

	// FMCG
	FMCG_SUB_INDUSTRY: 'fmcg_sub_industry',
	FMCG_BRAND_NUMBERS: 'fmcg_brand_numbers',
	FMCG_TURNOVER: 'fmcg_turnover',
	FMCG_STORE_TYPE: 'fmcg_store_type',
	FMCG_FROZEN_FOODS: 'fmcg_frozen_foods',

	// BCM
	BCM_SUB_INDUSTRY: 'bcm_sub_industry',
	// BCM_BRAND_NAME: 'bcm_brand_name',
	BCM_TURNOVER: 'bcm_turnover',

	// BCM BRANDS
	BCM_CEMENT_BRANDS : "bcm_cement_brands",
    BCM_STEEL_BRANDS : "bcm_steel_brands",
    BCM_PAINT_AND_HARDWARE_BRANDS : "bcm_paint_and_hardware_brands",
    BCM_PLUMBING_PIPE_AND_WATER_TANK_BRANDS : "bcm_plumbing_pipe_and_water_tank_brands",
    BCM_TILES_AND_ADHESIVE_BRANDS : "bcm_tiles_and_adhesive_brands",
    BCM_PLYWOOD_BRANDS : "bcm_plywood_brands",
    BCM_ELECTRICALS_SUPPLIERS_BRANDS : "bcm_electricals_suppliers_brands",

	// Common
	NEXT_GEN: "next_gen_participation",

	// Personal Profiler
	PREFERRED_LANGUAGE: 'preferred_language',
	MARITAL_STATUS: 'marital_status',
	MARRIAGE_ANNIVERSARY: 'marriage_anniversary',
	SPOUSE_BUSINESS_INVOLVEMENT: 'spouse_business_involvement',
	KIDS_COUNT: 'kids_count',
	KIDS_EDUCATION_COUNT: 'kids_education_count',
	PREFERRED_HOLIDAY_DESTINATION: 'preferred_holiday_destination',
	PREFERRED_DOMESTIC_DESTINATION: 'preferred_domestic_destination',
	PREFERRED_INTERNATIONAL_DESTINATION: 'preferred_international_destination',

	INSURANCE_INTEREST: 'insurance_opt_in',


	
};
